"use strict";

import "./dragsvg";
import { newConnNegotiated } from "./perf";
import { Elm } from "../tmp/elm";

{
	const selfInst = genID();
	const clientID = genID();
	let selfID;    // set below along with iceConfig
	let iceConfig; // set below along with selfID
	let icePeers = new Map();
	let pointerPeers = new Map();

	const pointerChanConfig = {
		ordered: false,
		maxPacketLifeTime: 500, // ms
		negotiated: true,
		id: 0
	};

	function genID(len) {
		let a = new Uint8Array(5);
		window.crypto.getRandomValues(a);
		return Array.from(a, n => n.toString(32)).join('');
	}

	class SignalingChannel {
		onmessage = null;

		constructor(id, inst) {
			this.open = true;
			this.id = id;
			this.inst = inst;
		}

		send(m) {
			if (!this.open) {
				return;
			}
			const body = {m: m, inst: selfInst};
			app.ports.noteToPeer.send({to: this.id, body: body});
		}

		deliver(m) {
			if (!this.open) {
				return;
			}
			if (this.onmessage) {
				return this.onmessage(m);
			}
		}

		addListener(f) {
			if (!this.open) {
				return;
			}
			this.listeners.push(f);
		}

		close() {
			this.open = false;
		}
	}

	class Peer {
		pointer = null;
		connected = false;

		static connect(id, inst, port) {
			const peer = new Peer(id, inst, iceConfig);
			icePeers.set(id, peer);
			peer.startPointer(port).then(() => pointerPeers.set(id, peer));
			return peer;
		}

		constructor(id, inst, ice) {
			this.sig = new SignalingChannel(id, inst);
			this.conn = newConnNegotiated(this.sig, selfID > id, ice);
		}

		async startPointer(port) {
			const dc = await this.conn.createDataChannel("pointer", pointerChanConfig);
			this.pointer = dc;

			dc.addEventListener("open", ev => {
				console.log("pointer channel open with player", this.sig.id);
				this.connected = true;
			});

			dc.addEventListener("close", ev => {
				this.connected = false;
			});

			dc.addEventListener("message", ev => {
				try {
					const pos = JSON.parse(ev.data);
					port.send({from: this.sig.id, pos: pos});
				} catch (err) {
					console.error(err);
				}
			});
		}

		close() {
			this.sig.close();
			this.conn.close();
		}
	}

	let app = Elm.Main.init({
		flags: {
			clientId: clientID,
			userAgent: navigator.userAgent,
			nickname: localStorage.getItem('nickname') || "",
		}
	});

	app.ports.saveNickname.subscribe(async (newNickname) => {
		localStorage.setItem('nickname', newNickname);
	});

	app.ports.setIceConfig.subscribe(async ([id, ice]) => {
		selfID = id;
		iceConfig = {
			iceServers: ice
		};
		console.log("got ice config, self id", id, iceConfig);
		const body = {m: {hello: "hello"}, inst: selfInst};
		app.ports.noteToPeer.send({to: -1, body: body});
	});

	app.ports.noteFromPeer.subscribe(async ({from, body}) => {
		if (!iceConfig) {
			return; // we are not ready, just ignore everything
		}
		const {m, inst} = body;
		if (!m) {
			return;
		}
		if (m.hello) {
			// The other side might not have been ready
			// when it got our first hello, so send one more now
			// that we are sure it is ready.
			const b2 = {m: {helloBack: "helloBack"}, inst: selfInst};
			app.ports.noteToPeer.send({to: from, body: b2});
		}
		let peer = icePeers.get(from);
		if (!peer && from != selfID) {
			// self is ready to connect && message is from a peer
			peer = Peer.connect(from, inst, app.ports.peerPointerPos);
		}
		if (peer && peer.sig.inst != inst) {
			// peer reloaded the page or something
			await peer.close();
			peer = Peer.connect(from, inst, app.ports.peerPointerPos);
		}
		if (peer) {
			peer.sig.deliver(m);
		}
	});

	app.ports.broadcastPointerPos.subscribe(async pos => {
		const data = JSON.stringify(pos);
		for (const [_, peer] of pointerPeers) {
			if (peer.connected) {
				peer.pointer.send(data);
			}
		}
	});

	app.ports.pointerCapture.subscribe(([id, on]) => {
		const elem = document.getElementById("dragarea");
		if (on) {
			elem.setPointerCapture(id);
		} else {
			elem.releasePointerCapture(id);
		}
	});
}
